import React from 'react';
import {
  Modal,
  CustomModalLayout,
  Box,
  Text,
  Badge
} from '@wix/design-system';

class LastUpdate extends React.Component {

    render() {
        return(
          <Modal
            isOpen={this.props.lastupdatePage}
            onRequestClose={() => this.props.contentOverlay('lastupdatePage', false)}
            shouldCloseOnOverlayClick
            screen="desktop"
          >
            <CustomModalLayout
              secondaryButtonText={I18n.t('installguide.close_modal')}
              secondaryButtonOnClick={() => this.props.contentOverlay('lastupdatePage', false)}
              onCloseButtonClick={() => this.props.contentOverlay('lastupdatePage', false)}
              title="Les dernières mises à jour de l'app"
              content={
                <Box direction="vertical">
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>28/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Les commandes livrées en point relais hors de France sont désormais correctement rattachées à leur service Colissimo. Jusqu'ici, quand vous choisissiez un point relais européen (Belgique, Allemagne, Pays-Bas…), la commande pouvait rester « non associée à un produit Colissimo » alors qu'un message de succès s'affichait, et la génération d'étiquette échouait ensuite. Si l'association échoue malgré tout, un message d'erreur s'affiche maintenant au lieu du message de succès.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>23/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Le prix de vos étiquettes s'affiche désormais dans l'application. Quand vous changez le mode de livraison d'une commande, le tarif de chaque option apparaît en face de celle-ci, HT et TTC : vous voyez ce que coûte une livraison en point relais avant de la choisir. Le tarif est ensuite conservé sur l'étiquette générée, sous son numéro de suivi, et dans une nouvelle colonne « Coût » des écrans Bordereaux et Suivi. Ces tarifs viennent directement de Colissimo et tiennent compte de votre contrat.
                    <br/><br/>
                    Ce service requiert une clé API : il ne fonctionne pas avec un identifiant et un mot de passe seuls. Le diagnostic de « Mon compte » comporte une ligne « Cotation tarifaire » qui vous dit s'il est actif sur votre contrat. Les étiquettes générées avant cette mise à jour n'ont pas de tarif enregistré : la colonne reste vide pour elles.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>18/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Trois nouveaux pays peuvent désormais être livrés par leur réseau postal local plutôt que par DPD : la Belgique, les Pays-Bas (PostNL) et l'Espagne (Correos). Ils rejoignent l'Allemagne, l'Autriche, l'Italie et le Luxembourg dans Configuration - Back Office, rubrique Réseau postal local. Les pays non cochés continuent d'être expédiés via DPD, comme avant.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>17/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Le numéro EORI est désormais vérifié à l'enregistrement de la configuration : il doit être composé de 2 lettres suivies de 9 chiffres (ex. FR123456789). Les aides et exemples du champ ont été mis à jour en conséquence. Si votre EORI est déjà enregistré dans un autre format, il reste en place et continue d'être transmis à Colissimo : vous pourrez le corriger à votre rythme.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>15/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Un diagnostic des services Colissimo est disponible dans « Mon compte », sous le bouton de vérification de vos paramètres de connexion. En un clic, vous voyez à quels web services votre contrat vous donne accès : génération d'étiquette, web service Point Relais et widget Point Relais au checkout. Utile si vous expédiez sous le contrat d'un logisticien : vous savez immédiatement si une option manque sur votre contrat, sans attendre de le découvrir lors d'une expédition.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>10/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Une commande supprimée de la liste peut de nouveau être récupérée : saisissez son numéro dans « Importer des commandes » et elle réapparaît avec ses étiquettes et son service Colissimo. L'import affiche désormais un bilan précis (commandes importées, restaurées, déjà présentes, introuvables) au lieu d'un succès systématique. Les étiquettes des commandes supprimées n'apparaissent plus dans les écrans Coliship, Suivi et Bordereaux.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>04/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Le champ de recherche des listes (commandes, étiquettes, bordereaux et suivi) a été corrigé : votre saisie n'est plus interrompue pendant le chargement des résultats, et la croix vide désormais le champ et rétablit la liste complète.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>04/09/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Vous pouvez désormais vous connecter à Colissimo avec votre clé API, le mode d'authentification recommandé par Colissimo. L'écran « Mon compte » a été repensé : la clé API est proposée en premier, l'identifiant et le mot de passe restent disponibles en mode alternatif. Le code tiers est également accessible dans les deux modes, si vous expédiez sous le contrat d'un logisticien.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>16/07/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Impression thermique : ajout d'un bouton pour tester la connexion à QZ Tray depuis la configuration, et repli automatique sur le kit Colissimo lorsque l'imprimante ne répond pas.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>13/07/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Nouvelle fenêtre d'impression des étiquettes, qui regroupe vos documents et lance l'impression sans quitter la liste des commandes.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>15/06/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Optimisation</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Les commandes livrées en point relais dont le point n'avait pas été enregistré sont désormais rattrapées automatiquement. La synchronisation des commandes a également été fiabilisée.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>12/06/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Le bouton de validation de commande est maintenant bloqué tant que votre client n'a pas choisi son point relais, et la page de confirmation affiche correctement le point sélectionné.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>09/06/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Vous choisissez désormais les types de points relais proposés à vos clients (bureaux de Poste, relais commerçants Pickup, consignes, voisins-relais…) depuis Configuration - Front Office. La recherche d'adresse bénéficie en plus d'une autocomplétion.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>08/06/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Nouvelle carte de sélection des points relais, aux couleurs de Colissimo et pensée pour le mobile, dans le tunnel de commande comme dans votre back-office. Elle remplace l'ancien widget Colissimo.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>26/05/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Correction des pages blanches à l'impression thermique des étiquettes au format PDF.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>21/05/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Impression en lot via QZ Tray, avec la prise en charge de nouveaux protocoles d'imprimante (dont MUNBYN).
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>20/05/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    L'assurance est désormais disponible sur les étiquettes de retour, au même titre que sur les étiquettes d'expédition.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>18/05/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Vous pouvez désormais choisir le niveau d'assurance directement depuis la liste des commandes. Cochez la case "Assurance" pour les commandes éligibles, puis cliquez sur le montant affiché pour sélectionner la valeur souhaitée (150 € à 5000 € HT).
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>17/05/2026&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Correction</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Correction de l'impression des étiquettes de retour pour les boutiques équipées d'une imprimante thermique. Les étiquettes retour étant toujours générées en PDF, le bouton « Imprimer » ouvre désormais directement le PDF dans un nouvel onglet.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>21/07/2025&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="Opx">
                    Ajout de la configuration SMTP dans les options avancées afin que vous puissiez envoyer vos étiquettes de retour depuis votre propre SMTP. <br/>
                    Cf Configuration - 5 Options avancées
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>19/06/2025&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralStandard" size="small">Optimisation</Badge>
                  </Box>
                  <Text marginTop="Opx">
                    Mise à jour de l'affichage sélection des points relais pour le rendre compatible avec le nouveau checkout UI de Wix.
                  </Text>
                  <br/>
                  <Box marginBottom="12px" width="100%" verticalAlign='middle'>
                    <Text>
                      <b>17/06/2025&nbsp;</b>
                    </Text>
                    <Badge uppercase="false" skin="neutralSuccess" size="small">Fonctionnalité</Badge>
                  </Box>
                  <Text marginTop="0px">
                    Ajout de la configuration SMTP dans les options avancées qui permet d'envoyer les étiquettes d'expéditon et de retour sur un SFTP distant lors de leur génération.
                  </Text>
                </Box>
              }
            />
          </Modal>
        )
    }
}

export default LastUpdate
